import React, { Component } from 'react'
import { observer } from "mobx-react"
import { Icon, Collapse, Select, InputNumber, message } from 'antd'
import NavViews from '../../stores/NavViews';
import { FaLifeRing, FaEthereum } from 'react-icons/fa';
import { ethMultiplier } from '../../constants';
import OracleRegisteredBadge from './OracleRegisteredBadge';

import { registerOracle } from "../../contract/OraclesController"
import { registerOracle as registerOracleApi } from '../../api-calls/oracles'
import { mvuMultiplier } from '../../constants';
import OraclePropBets from './OraclePropBets';
const Panel = Collapse.Panel;
const Option = Select.Option;
@observer(["CategoriesStore", "TeamStore", "AdminStore", "ViewStore", "eventStore", "web3Store", "CustomRouter", "AuthStore"])
class EventsByCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chosenOracleTeam: "",
            registered: false, eventsToDisplay: <Icon type="loading" style={{ position: 'relative', padding: 10, fontSize: "30px", top: "200px", left: "45%", color: "#1890ff" }} />,
            categoryName: "Category"
        }
        this.handleOracleSubmit = this.handleOracleSubmit.bind(this);
        this.onTeamClick = this.onTeamClick.bind(this);
    } 

    renderOracleEventDiv(event) {
        const { TeamStore, eventStore } = this.props;
        const { CustomRouter } = this.props;
        const { router: { goTo } } = CustomRouter;
        let teams = [];
        let totalPoolAmount = 0;

       
        event.teams.forEach(team => {
            teams.push(TeamStore.teams.get(team))
        });

        event.amountBetForTeam.forEach(amount => {
            totalPoolAmount += amount;

        });
        event.drawPossible ? totalPoolAmount += event.amountBetForDraw : null;
        //   console.log("teams for " + event._id + " -- " + JSON.stringify(teams))
        return <div className="space-mono" style={{ textAlign: "center", width: "100%", color: "rgba(255,255,255,0.5)" }} onClick={() => {
            if (!this.props.oracles) {
                goTo(NavViews.singleEvent, { eventID: event._id }, CustomRouter)
            }
        }}>
        <OracleRegisteredBadge event={event} />
           
            <br />
            <p style={{ fontSize: "16pt" }} >{teams[0].name} vs {teams[1].name} {(teams.length > 2 ? " and " + (teams.length - 2) + " more" : "")}</p>
            {/* <p style={{ backgroundColor: "rgba(255,255,255, 0.25)", borderRadius: "15px" }}><span style={{ fontSize: "14pt", color: teams[0].colors[0] }}>{teams[0].name}</span> vs <span style={{ fontSize: "14pt", color: teams[1].colors[0] }}>{teams[1].name}</span> {(teams.length > 2 ? " and " + (teams.length - 2) + " more" : "")}</p> */}
            {/* <div style={{ fontSize: "14pt", padding: "6px" }}>
                <span style={{ border: "solid rgba(255,255,255,0.5) 1px", padding: "4px", borderRadius: "9px" }}><span style={{ color: '#27f727' }}>2.1 <FaEthereum/></span> 1-1</span>
            </div> */}
            <div style={{ fontSize: "14pt", padding: "6px" }}>
                <span style={{ border: "solid rgba(255,255,255,0.5) 1px", padding: "4px", borderRadius: "9px" }}><span style={{ color: '#27f727' }}>{(totalPoolAmount / ethMultiplier).toFixed(4)} <FaEthereum /></span> POOL</span>
            </div>
            <div style={{ position: "relative", top: "15px", color: "#1890ff" }} className="raleway">{new Date(event.startTime * 1000).toLocaleTimeString()}</div>
            <img style={{ position: "relative", right: "40%", bottom: "40px" }} height="8%" width="8%" src={teams[0].logoUrl} />

            <img style={{ position: "relative", left: "40%", bottom: "40px" }} height="8%" width="8%" src={teams[1].logoUrl} />

            <div style={{ position: "relative", bottom: "10px" }} className="raleway">{new Date(event.startTime * 1000).toLocaleDateString()}</div>
            <div>
                <Select style={{
                    // fontFamily: "Poppins",
                    // webkitBixSizing: 'border-box',
                    // boxSizing: 'border-box',
                    // margin: 0,
                    padding: 5,
                    // listStyle: 'none',
                    position: 'relative',
                    display: 'inline-block',
                    //  padding: '4px 11px',

                    width: '60%',
                    height: '26px',
                    fontSize: '14px',
                    lineHeight: 1.5,
                    color: '#011828',
                    //  backgroundColor: 'blue',


                    //  border: '1px solid #d9d9d9',
                    //  borderRadius: '4px',
                    //  borderColor: '#40a9ff'
                }}
                    theme="dark" placeholder={"Choose winning team"} dropdownStyle={{
                        //     fontFamily: "Poppins",
                        // webkitBixSizing: 'border-box',
                        // boxSizing: 'border-box',
                        // margin: 0,
                        // padding: 0,
                        // listStyle: 'none',
                        // position: 'relative',
                        // display: 'inline-block',
                        // padding: '4px 11px',

                        // width: '100%',
                        // height: '26px',
                        // fontSize: '14px',
                        // lineHeight: 1.5,
                        //  color: 'rgba(255, 255, 255, 0.65)',
                        backgroundColor: 'rgba(255,255,255,0.6)',

                        //border: '1px solid #d9d9d9',
                        //borderRadius: '4px',
                        //borderColor: '#40a9ff'
                    }}
                    onChange={this.onTeamClick.bind(this)} >
                    {this.renderTeamSelect(teams, event)}
                </Select>
            </div>
            <br />
            <InputNumber theme="dark" defaultValue={this.props.AdminStore.minOracleStake}

                precision={3}
                step={0.01}
                min={this.props.AdminStore.minOracleStake}
                //max={10}

                style={{
                    fontFamily: "Poppins",
                    // webkitBixSizing: 'border-box',
                    boxSizing: 'border-box',
                    margin: 0,
                    padding: 0,
                    listStyle: 'none',
                    position: 'relative',
                    display: 'inline-block',
                    padding: '4px 11px',

                    width: '100%',
                    height: '32px',
                    fontSize: '14px',
                    lineHeight: 1.5,
                    color: 'rgba(255, 255, 255, 0.65)',
                    backgroundColor: 'rgba(255, 255, 255, 0)',

                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    borderColor: '#40a9ff'
                }}
                size="small" /><button onClick={this.handleOracleSubmit.bind(this, event)}>SUBMIT</button>
            <br />
            <br />
            <OraclePropBets originalEvent={event} eventId={event._id} relatedPropEvents={event.relatedPropEvents} />
            {/* <button>Place Bet</button> */}
            <div style={{ width: "100%", backgroundColor: "#f48541", height: "2px" }} />
            {/* {event.relatedPropEvents.length > 0 ? <Collapse>
                <Panel header="View Prop Bets" key="1">Prop BEts  .....</Panel></Collapse> : ""} */}
            {/* <br /> */}
        </div>
    }


    onTeamClick(teamId) {
        this.setState({
            chosenOracleTeam: teamId
        });
    }

    handleOracleSubmit = (event) => {
        const { CustomRouter } = this.props;
        const { eventStore, AuthStore, AdminStore, web3Store } = this.props;
        const { router: { params } } = CustomRouter;


        let self = this;

        if (!AdminStore.oracleStatus) {
            message.error("You must be a verified Oracle!");

        } else {

            if (this.state.chosenOracleTeam == "") {
                message.warning("You must choose a winning team!");
            } else {
                if (this.state.oracleStake == 0 || isNaN(this.state.oracleStake)) {
                    message.warning("You must meet the minimum oracle stake which is " + AdminStore.minOracleStake + " MVU");
                } else {
                    this.setState({
                        oracleModalVisible: false,
                    });

                    let eventBytes32Id = event.bytes32Id;
                    let mvuStake = Number(this.state.oracleStake) * mvuMultiplier;
                    let winnerVote = 0;

                    event.teams.forEach((team, index) => {
                        if (team == this.state.chosenOracleTeam) {
                            winnerVote = index + 1;
                        }
                    }); 
                    if (this.state.chosenOracleTeam == "draw"){
                        winnerVote = event.teams.length + 1;
                    }
                    console.log("chosen oracle team " + this.state.chosenOracleTeam);
                    console.log("event ID " + event._id);
                    console.log("bytes ID " + eventBytes32Id);
                    console.log("stake " + mvuStake);
                    console.log("vote " + winnerVote);
                    registerOracle(eventBytes32Id, mvuStake, winnerVote).then(function (result) {
                        if (String(result).includes('User denied transaction signature')) {
                            message.warning("Metamask transaction denied! Not registered as Oracle.");
                        } else {
                            return registerOracleApi(AuthStore.userAuth.auth.accessToken, eventBytes32Id, event._id, web3Store.account, mvuStake, winnerVote).then(() => {
                                console.log("registerOracleApi finished");

                            });
                        }

                    });

                }
            }

        }


    }
    renderTeamSelect(teams, event) {
        let menuList = []
        let self = this;

        teams.forEach(function (team) {
            //console.log("leagueId: " + self.state.league+ "   team.league: " + team.league);

            menuList.push(<Option
                //     style={{
                //     fontFamily: "Poppins",
                //     webkitBixSizing: 'border-box',
                //     boxSizing: 'border-box',
                //     margin: 0,
                //     padding: 0,
                //     listStyle: 'none',
                //     position: 'relative',
                //     display: 'inline-block',
                //     padding: '4px 11px',

                //     width: '100%',
                //     height: '26px',
                //     fontSize: '14px',
                //     lineHeight: 1.5,
                //     color: 'rgba(255, 255, 255, 0.65)',
                //     backgroundColor: 'blue',

                //     border: '1px solid #d9d9d9',
                //     borderRadius: '4px',
                //     borderColor: '#40a9ff'
                // }} 
                key={team._id} value={team._id}>
                {team.name}
            </Option>);
        });

        if (event.drawPossible) {
            menuList.push(<Option key={"draw"} value={"draw"}>
                Draw
            </Option>);

        }

        return menuList;

    }
    renderEventDiv(event) {
        const { TeamStore, eventStore } = this.props;
        const { CustomRouter } = this.props;
        const { router: { goTo } } = CustomRouter;
        let teams = [];
        let totalPoolAmount = 0;
        event.teams.forEach(team => {
            teams.push(TeamStore.teams.get(team))
        });

        event.amountBetForTeam.forEach(amount => {
            totalPoolAmount += amount;

        });

        event.drawPossible ? totalPoolAmount += event.amountBetForDraw : null;
        //   console.log("teams for " + event._id + " -- " + JSON.stringify(teams))
        return <div className="space-mono" style={{ textAlign: "center", width: "100%", color: "rgba(255,255,255,0.5)" }} onClick={() => {

            goTo(NavViews.singleEvent, { eventID: event._id }, CustomRouter);

        }}>
            <br />
            <p style={{ fontSize: "16pt" }} >{teams[0].name} vs {teams[1].name} {(teams.length > 2 ? " and " + (teams.length - 2) + " more" : "")}</p>
            {/* <p style={{ backgroundColor: "rgba(255,255,255, 0.25)", borderRadius: "15px" }}><span style={{ fontSize: "14pt", color: teams[0].colors[0] }}>{teams[0].name}</span> vs <span style={{ fontSize: "14pt", color: teams[1].colors[0] }}>{teams[1].name}</span> {(teams.length > 2 ? " and " + (teams.length - 2) + " more" : "")}</p> */}
            {/* <div style={{ fontSize: "14pt", padding: "6px" }}>
                <span style={{ border: "solid rgba(255,255,255,0.5) 1px", padding: "4px", borderRadius: "9px" }}><span style={{ color: '#27f727' }}>2.1 <FaEthereum/></span> 1-1</span>
            </div> */}
            <div style={{ fontSize: "14pt", padding: "6px" }}>
                <span style={{ border: "solid rgba(255,255,255,0.5) 1px", padding: "4px", borderRadius: "9px" }}><span style={{ color: '#27f727' }}>{(totalPoolAmount / ethMultiplier).toFixed(4)} <FaEthereum /></span> POOL</span>
            </div>
            <div style={{ position: "relative", top: "15px", color: "#1890ff" }} className="raleway">{new Date(event.startTime * 1000).toLocaleTimeString()}</div>
            <img style={{ position: "relative", right: "40%", bottom: "40px" }} height="8%" width="8%" src={teams[0].logoUrl} />

            <img style={{ position: "relative", left: "40%", bottom: "40px" }} height="8%" width="8%" src={teams[1].logoUrl} />

            <div style={{ position: "relative", bottom: "10px" }} className="raleway">{new Date(event.startTime * 1000).toLocaleDateString()}</div>
            {/* <button>Place Bet</button> */}
            <div style={{ width: "100%", backgroundColor: "rgba(255,255,255,0.1)", height: "2px" }} />
            {/* {event.relatedPropEvents.length > 0 ? <Collapse>
                <Panel header="View Prop Bets" key="1">Prop BEts  .....</Panel></Collapse> : ""} */}
            {/* <br /> */}
        </div>
    }

    renderEvents() {
        const { eventStore, AdminStore } = this.props;
        let eventList = this.props.eventList;
        let timeNow = new Date().getTime() / 1000;

        // console.log('Time now:' + timeNow);
        if (eventList.length == 0 && !this.state.eventsChecked) {
            eventList = [];
            for (let event of eventStore.events.values()) {

                if (event.startTime + event.duration > timeNow) {
                    if (!event.cancelled && !event.finalized && !event.isPropEvent && event.categoryId === this.props.category && !this.props.oracles) {
                        //eventList.push(this.renderEventCollapse(event));
                        eventList.push(this.renderEventDiv(event));
                    }
                }
                else if (event.startTime + event.duration <= timeNow && timeNow < event.startTime + event.duration + AdminStore.oraclePeriod) {
                    if (!event.cancelled && !event.finalized && !event.isPropEvent && event.categoryId === this.props.category && this.props.oracles) {
                        //eventList.push(this.renderEventCollapse(event));
                        eventList.push(this.renderOracleEventDiv(event));
                    }

                }
            }
            this.setState({
                eventList: eventList, previousTotalFeatEvents: eventList.length, eventsChecked: true
                , eventsToDisplay: (eventList.length > 0 ?
                    <div style={{ backgroundColor: "rgba(0,0,0,0.3)", paddingTop: 40, paddingBottom: 40, paddingLeft: 20, paddingRight: 20 }}>
                        {eventList}
                    </div>
                    : <div className="my-bets-page-cards-bet-options-title">
                        <Icon style={{ position: 'relative', padding: 10, fontSize: "30px", top: "200px" }} type="calendar" /><h3>No Events Found</h3>
                    </div>)
            });
        } else {
            this.setState({
                eventsToDisplay: (eventList.length > 0 ?
                    <div style={{ backgroundColor: "rgba(0,0,0,0.3)", paddingTop: 10, paddingBottom: 40, paddingLeft: 20, paddingRight: 20 }}>
                        {eventList}
                    </div>
                    : <div className="my-bets-page-cards-bet-options-title">
                        <Icon style={{ position: 'relative', padding: 10, fontSize: "30px", top: "200px" }} type="calendar" /><h3>No Events Found</h3>
                    </div>)
            })
        }
        this.setState({ categoryName: this.props.CategoriesStore.categories.get(this.props.category).title, eventsRendered: true });
     
    }
    render() {
        if (!this.state.eventsRendered && this.props.eventStore.loaded) {
            this.setState({ categoryName: this.props.CategoriesStore.categories.get(this.props.category).title, oracleStake: this.props.AdminStore.minOracleStake });
            this.renderEvents();
        }
        return (
            <div>
                <h1 className="raleway">{this.props.CategoriesStore.categories.get(this.props.category).title.toUpperCase()}  <img src={require(`../../assets/img/categories/${this.props.CategoriesStore.categories.get(this.props.category).title.toLowerCase()}.png`)}/></h1>
                <div style={{ height: "500px", backgroundColor: "rgba(0,0,0,0.3)", overflow: "scroll" }}>
                    {this.state.eventsToDisplay}
                </div>
            </div>
        )
    }
}
export default EventsByCategory;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/EventsByCategory.js